import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=9840b9d4&"
import script from "./Ticker.vue?vue&type=script&lang=js&"
export * from "./Ticker.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-live-chat-ticker-renderer.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/youtube/yt-live-chat-ticker-paid-message-item-renderer.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports